export default function getFormDataByPrefix(formData, prefix) {
    const data = {};

    for (const [key, value] of formData.entries()) {
        if (key.startsWith(prefix)) {
            const match = key.match(new RegExp(`^${prefix}\\[([^\\]]+)\\](\\[\\])?$`));
            if (match) {
                const fieldName = match[1];
                const isArray = match[2] === '[]';

                if (isArray) {
                    console.log(fieldName);
                    if (!data[fieldName]) {
                        data[fieldName] = [];
                    }
                    data[fieldName].push(value);
                } else {
                    data[fieldName] = value;
                }
            }
        }
    }

    return data;
}
